import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DECORATOR__data__do_not_populate_from_linked } from '../../_base/_decorators/DECORATOR__data__do_not_populate_from_linked';
import { DECORATOR__data__reset_if_not_linked } from '../../_base/_decorators/DECORATOR__data__reset_if_not_linked';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__ml_asset_t2i_adapter } from '../../ml_asset/guidance/FIELD__ml_asset_t2i_adapter';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

@DECORATOR__class_serialization_tested_for_hash
export class FIELD__list_t2i_adapter extends FIELD__list_base_generic<FIELD__ml_asset_t2i_adapter> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_LIST__T2I_ADAPTER;

  /*
   *
   */

  sort_items(items: FIELD__ml_asset_t2i_adapter[]) {
    items.sort(FIELD__ml_asset_t2i_adapter.sort_by_hash);
  }

  /*
   *
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.ML_ASSET__T2I_ADAPTER;
  }

  @DECORATOR__data__reset_if_not_linked
  @DECORATOR__data__do_not_populate_from_linked
  post_init(): void {
    super.post_init();
  }

  protected override _create_item_internal__default() {
    return new FIELD__ml_asset_t2i_adapter();
  }
}
